<template>
	<div>

		<div class="form-group">
			<label>
				<input type="checkbox" @click="toggleDateFilters()" :checked="showdatefilters">
				{{ $t('filter-by-date-range') }}
			</label>
		</div>
		<div class="form-group" v-if="showdatefilters">
			<label>{{ $t('from') }}</label>
			<select class="form-control" v-model="dataelement.data.date_range_from">
				<option value=""></option>
				<option v-for="item in 12" :value="item" :key="item">{{ $t('month-long-' + item) }}</option>
				<option value="other">{{ $t('other') }}</option>
			</select>
		</div>
		<div class="row" v-if="showdatefilters && dataelement.data.date_range_from=='other'">
			<div class="col-md-3">
				<div class="form-group">
					<label>{{ $t('period') }}</label>
					<input type="number" class="form-control" v-model="dataelement.data.date_range_length">
				</div>
			</div>
			<div class="col-md-9">
				<div class="form-group">
					<label>{{ $t('interval') }}</label>
					<select class="form-control" v-model="dataelement.data.date_range_denominator">
						<option value="MONTH">{{ $t('months') }}</option>
						<option value="WEEK">{{ $t('weeks') }}</option>
						<option value="DAY">{{ $t('days') }}</option>
					</select>
				</div>
			</div>
		</div>

		<template v-if="showProcedureFilter">
			<div class="form-group">
				<label>{{ $t('procedure') }}</label>
				<select class="form-control" v-model="ProcedureID" @change="getFormElements">
					<option disabled>{{ $t('select') }}</option>
					<option value="0">{{ $t('all') }}</option>
					<option v-for="procedure in procedures" :key="procedure.ProcedureID" :value="procedure.ProcedureID">
						{{ procedure.Caption }}
					</option>
				</select>
			</div>
		</template>

		<template v-if="showSessionType">
			<div class="form-group">
				<label>{{ $t('session-type') }}</label>
				<select class="form-control" v-model="SessionTypeID">
					<option value="">{{ $t('all') }}</option>
					<option v-for="participationType in $config.getValue('participationTypes')" :key="participationType.id" :value="participationType.id">
						{{ participationType.name }}
					</option>
				</select>
			</div>
		</template>

		<template v-if="showGradeFilters">
			<label>{{ $t('grades') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Grade"
					v-if="!dataelement.data.grades.length"
					@click="openGradesModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(grade, index) in dataelement.data.grades"
					v-bind:key="index"
				>
					{{ grade.id }}
					<a @click="removeGrade(grade)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="dataelement.data.grades.length"
					@click="openGradesModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>
			<div class="form-group" v-for="grade in dataelement.data.grades" :key="grade.id">
				<label>{{ grade.caption }}</label>
				<div
					class="pseudo-input mb-3"
				>
					<input
						type="search"
						class="input-bare w-full flex-1"
						placeholder="Select"
						v-if="!grade.marks.length"
						@click="openGradeValuesModal(grade)"
					/>
					<span
						class="badge badge-secondary badge-sm mr-2 mb-2"
						v-for="(mark, index) in grade.marks"
						v-bind:key="index"
					>
						{{getGradeCaption(grade, mark)}}
						<a @click="removeGradeValue(grade, mark)"><b-icon icon="x"></b-icon></a>
					</span>
					<span
						class="badge badge-primary badge-sm mr-2 mb-2"
						v-if="grade.marks.length"
						@click="openGradeValuesModal(grade)"
					>
						<b-icon icon="plus"></b-icon> {{ $t("add") }}
					</span>
				</div>

			</div>
		</template>

		<template v-if="showTSCompTestFilter && $config.hasModule('tests')">

			<!-- after comp test dropdown -->
			<div class="form-group">
				<label>{{ $t('test') }}</label>
				<select class="form-control" v-model="CompetencyTestAttachedID">
					<option :value="null">n/a</option>
					<option v-for="test in competencyTests" :key="test.CompetencyTestID" :value="test.CompetencyTestID">
						{{ test.Name }}
					</option>
				</select>
			</div>

			<!-- after comp test dropdown -->
			<div class="form-group">
				<label>{{ $t('only-after-test-passed') }}</label>
				<select class="form-control" v-model="CompetencyTestID">
					<option :value="null">n/a</option>
					<option v-for="test in competencyTests" :key="test.CompetencyTestID" :value="test.CompetencyTestID">
						{{ test.Name }}
					</option>
				</select>
			</div>
		</template>

		<template v-if="showTTSessiontypeFilters">
			<label>{{ $t('session-type') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					:placeholder="$t('session-type')"
					v-if="!dataelement.data.ttsessiontypes || !dataelement.data.ttsessiontypes.length"
					@click="openTTSessiontypesModal(dataelement.data.ttsessiontypes)"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(item, index) in dataelement.data.ttsessiontypes"
					v-bind:key="index"
				>
					{{ item.name }}
					<a @click="removeTTSessiontype(dataelement.data.ttsessiontypes, item)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="dataelement.data.ttsessiontypes && dataelement.data.ttsessiontypes.length"
					@click="openTTSessiontypesModal(dataelement.data.ttsessiontypes)"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>
			<label>{{ $t('excludes-session-type') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					:placeholder="$t('session-type')"
					v-if="!dataelement.data.not_ttsessiontypes || !dataelement.data.not_ttsessiontypes.length"
					@click="openTTSessiontypesModal(dataelement.data.not_ttsessiontypes)"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(item, index) in dataelement.data.not_ttsessiontypes"
					v-bind:key="index"
				>
					{{ item.ttsessiontype_name }}
					<a @click="removeTTSessiontype(dataelement.data.not_ttsessiontypes, item)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="dataelement.data.not_ttsessiontypes && dataelement.data.not_ttsessiontypes.length"
					@click="openTTSessiontypesModal(dataelement.data.not_ttsessiontypes)"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>
		</template>

		<template v-if="showSpecialtyAndClinicFilters">

			<!-- specialty multiselect -->
			<label>{{ $t('specialty') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Specialty"
					v-if="!selectedSpecialties.length"
					@click="openSpecialtiesModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(specialty, index) in selectedSpecialties"
					v-bind:key="index"
				>
					{{ specialty.caption }}
					<a @click="removeSpecialty(specialty)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="selectedSpecialties.length"
					@click="openSpecialtiesModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
				<!--<span
					class="badge badge-danger badge-sm mr-2 mb-2"
					v-if="selectedSpecialties.length"
					@click="selectedSpecialties=[]"
				>
					<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
				</span>-->
			</div>

			<!-- clinic multiselect -->
			<label>{{ $t('clinic') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Clinic"
					v-if="!selectedClinics.length"
					@click="openClinicsModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(clinic, index) in selectedClinics"
					v-bind:key="index"
				>
					{{ clinic.name }}
					<a @click="removeClinic(clinic)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="selectedClinics.length"
					@click="openClinicsModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
				<!--<span
					class="badge badge-danger badge-sm mr-2 mb-2"
					v-if="selectedClinics.length"
					@click="selectedClinics=[]"
				>
					<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
				</span>-->
			</div>
		</template>

		<template v-if="showCountFilter">
			<!-- count dropdown -->
			<div class="form-group">
				<label>{{ $t('count') }}</label>
				<select class="form-control" v-model="countType" @change="changeCount">
					<template v-if="(datasource == 'formelement')">
						<option :value="null">{{ $t("procedures") }}</option>
						<option value="sessions">{{ $t("sessions") }}</option>
						<option v-for="formElement in selectedFormElements" :key="formElement.FormElementID" :value="formElement.Name">{{ formElement.Name }}</option>
						<option v-for="formElement in selectedFormElements" :key="`${formElement.FormElementID}.sum`" :value="(`${formElement.Name}.sum`)">{{ formElement.Name }} ({{$t('sum_values')}})</option>
					</template>
					<template v-else>
						<option :value="null">Responses</option>
						<option v-for="(formField, i) in selectedFormFields" :key="i" :value="formField.name">{{ formField.caption }}</option>
					</template>
				</select>
			</div>
		</template>

		<template v-if="showGradeFieldFilter && countType">
			<!-- the field just chosen above (countType) other than the default
			     "Responses" might be a grade scale, but we can't tell for sure - ask -->
			<div class="form-group">
				<CheckboxInput
					:label="$t('this-is-a-grade')"
					:value="isGrade"
					@input="value => isGrade = value"
				/>
			</div>

			<!-- optional pass/fail cutoff: collapses the (possibly many-valued)
			     grade scale into a dichotomy - anything at or above this option
			     counts as a pass. The highest-ranked option a user has ever
			     submitted for the field is reported as their attained grade,
			     ranked by the field's own option order (first = lowest, last = highest) -->
			<div class="form-group" v-if="isGrade && gradeFieldOptions.length">
				<label>{{ $t('passing-grade') }}</label>
				<select class="form-control" v-model="gradePassValue">
					<option :value="null">{{ $t("none") }}</option>
					<option v-for="opt in gradeFieldOptions" :key="opt.value" :value="opt.value">{{ opt.caption }}</option>
				</select>
			</div>
		</template>

		<template v-if="showFormElementFilter">

			<!-- form element multiselect -->
			<label>{{ $t('form-element') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Select"
					v-if="!selectedFormElements.length"
					@click="openFormElementsModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(formElement, index) in selectedFormElements"
					v-bind:key="index"
				>
					{{ formElement.Name }}
					<a @click="removeFormElement(formElement)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="selectedFormElements.length"
					@click="openFormElementsModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>
		</template>

		<div class="form-group" v-for="formElement in selectedFormElements" :key="formElement.FormElementID">
			<label>{{ formElement.Name }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Select"
					v-if="!formElement.value.length"
					@click="openFormElementValuesModal(formElement)"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(formElementValue, index) in formElement.value"
					v-bind:key="index"
				>
					{{ getFormElementValueCaptionFromValue(formElement, formElementValue) }}
					<a @click="removeFormElementValue(formElementValue, formElement)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="formElement.value.length"
					@click="openFormElementValuesModal(formElement)"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>

		</div>

		<template v-if="showTagFilters">
            <div class="form-group">
				<label class="font-bold">{{ $t("tags") }}</label>
				<TagPicker
					:tags="selectedTags"
				/>
			</div>
		</template>

		<template v-if="showCompetencyTestFilters">

            <div class="form-group">
                <label>{{ $t('test') }}</label>
				<select class="form-control" v-model="competencyTestFilters.competencytest_id">
					<option :value="null">{{ $t("any") }}</option>
					<option v-for="test in competencyTests" :key="test.CompetencyTestID" :value="test.CompetencyTestID">
						{{ test.Code }} {{ test.Name }}
					</option>
				</select>
            </div>

            <!--
            <div class="form-group">
                <label>Student Year</label>
                <select class="form-control" v-model="competencyTestFilters.studentyear">
               		<option :value="null">{{ $t("any") }}</option>

	                <template v-if="competencyTestFilters.course">
	     				<template v-for="(programme) in $config.getValue('programmes')">
	    					<template v-if="programme.Id == competencyTestFilters.course">
								<option v-for="year in parseInt(programme.CourseLengthYears)+1" :key="year" :value="year">
									<template v-if="(year == parseInt(programme.CourseLengthYears)+1)">Graduated</template>
									<template v-else>{{ year }}</template>
								</option>
							</template>
						</template>
					</template>
					<template v-else>
						<option v-for="year in 5" :key="year" :value="year">
							{{ year }}
						</option>
					</template>
				</select>
            </div>
            <div class="form-group">
                <label>Course</label>
    			<select class="form-control" v-model="competencyTestFilters.course">
    				<option :value="null">{{ $t("any") }}</option>
    				<option v-for="programme in $config.getValue('programmes')" :value="programme.Id" :key="programme.Id">{{ programme.Name }}</option>
    			</select>
            </div>
            <div class="form-group">
                <label>Year Group</label>
                <input class="form-control" v-model="competencyTestFilters.yeargroup">
            </div>
            <div class="form-group">
                <label>Firm ID</label>
                <input class="form-control" v-model="competencyTestFilters.firmid">
            </div>
        	-->

		</template>

		<template v-if="showFormFilters">
			<label>{{ $t('form') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Form"
					v-if="!selectedForms.length"
					@click="openFormsModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(form, index) in selectedForms"
					v-bind:key="index"
				>
					{{ form.title }}
					<a @click="removeForm(form)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="selectedForms.length"
					@click="openFormsModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>
            <label>{{$t('status')}}</label>
            <CheckboxInput
                :label="$t('completed')"
                :value="form_statuses.completed"
                @input="value => form_statuses.completed = value"
            />
            <CheckboxInput
                :label="$t('reviewed')"
                :value="form_statuses.reviewed"
                @input="value => form_statuses.reviewed = value"
            />
            <CheckboxInput
                :label="$t('signed-off')"
                :value="form_statuses.signed_off"
                @input="value => form_statuses.signed_off = value"
            />

            <label>{{$t('user')}}</label>
            <CheckboxInput
                :label="$t('form-is-about-another-user')"
                :value="user_subject"
                @input="value => user_subject = value"
            />
            

			<label>{{ $t('form-fields') }}</label>
			<div
				class="pseudo-input mb-3"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					placeholder="Form Field"
					v-if="!selectedFormFields.length"
					@click="openFormFieldsModal"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(formField, index) in selectedFormFields"
					v-bind:key="index"
				>
					{{ formField.caption }}
					<a @click="removeFormField(formField)"><b-icon icon="x"></b-icon></a>
				</span>
				<span
					class="badge badge-primary badge-sm mr-2 mb-2"
					v-if="selectedFormFields.length"
					@click="openFormFieldsModal"
				>
					<b-icon icon="plus"></b-icon> {{ $t("add") }}
				</span>
			</div>

			<div class="form-group" v-for="(formField, i) in selectedFormFields" :key="i">
				<label>{{ formField.caption }}</label>
				<template v-if="(formField.type == 'number')">
		            <div class="form-group">
		                <label>Greater than (&gt;)</label>
		                <input class="form-control" type="number" v-model="formField.min">
		            </div>
		            <div class="form-group">
		                <label>Less than (&lt;)</label>
		                <input class="form-control" type="number" v-model="formField.max">
		            </div>
				</template>
				<template v-else>
					<div
						class="pseudo-input mb-3"
					>
						<input
							type="search"
							class="input-bare w-full flex-1"
							placeholder="Select"
							v-if="!formField.value.length"
							@click="openFormFieldValuesModal(formField)"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(formFieldValue, index) in formField.value"
							v-bind:key="index"
						>
							{{ getFormFieldValueCaptionFromValue(formField, formFieldValue) }}
							<a @click="removeFormFieldValue(formFieldValue, formField)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="formField.value.length"
							@click="openFormFieldValuesModal(formField)"
						>
							<b-icon icon="plus"></b-icon> {{ $t("add") }}
						</span>
					</div>
				</template>
			</div>

			<div class="form-group" v-if="datasource == 'formscores'">
				<label>{{ $t('divisor') }}</label>
				<input class="form-control" type="number" step="any" v-model="divisor">
			</div>

		</template>
	</div>
</template>

<script>
import TagPicker from "src/components/Tags/TagPicker";
import CheckboxInput from "src/components/Inputs/CheckboxInput";
export default {
	components: {
		TagPicker,
        CheckboxInput
	},
	name: 'DataElementFilters',
	props: ['dataelement', 'datasource', 'procedures', 'grades', 'ttsessionypes', 'notttsessiontypes', 'competencyTests', 'clinics', 'specialties', 'forms', 'formFields', 'filterDataReady'],
	data() {
		return {

			showdatefilters: false,

			SessionTypeID: null,
			ProcedureID: null,
			CompetencyTestID: null,
			CompetencyTestAttachedID: null,
			selectedSpecialties: [],
			selectedFormElements: [],
			selectedClinics: [],
			countType: null,
			selectedForms: [],
			selectedFormFields: [],
			selectedTags: [],

			ttsessiontypes: [],
			not_ttsessiontypes: [],

			formElements: [],
			isGrade: false,
			gradePassValue: null,
			competencyTestFilters: {
				competencytest_id: null,
				/*studentyear: null,
				course: null,
				yeargroup: null,
				firmid: null*/
			},
            form_statuses: {
                completed: false,
                signed_off: false,
                reviewed: false
            },
            user_subject: false,
            divisor: null

		};
	},
	watch: {
		filterDataReady(ready) {
			if(ready) {
				this.loadDataElement();
				if(this.dataelement.data.date_range_length || this.dataelement.data.date_range_from){
					this.showdatefilters = true;
					if(this.dataelement.data.date_range_length){
						this.dataelement.data.date_range_from = 'other';
					}
				}
			}
		},

		datasource(newVal, oldVal) {
			if(oldVal) {
				//this.resetData();
			}
		}
	},
	mounted() {
		this.getTTSessiontypes();
	},
	methods: {
		getErrors() {
			const errors = [];
			if(this.datasource == 'formelement') {
				if(!this.ProcedureID) {
					errors.push('Please select a Procedure.');
				}
				if(!this.selectedFormElements.length) {
					errors.push('Please select a Form Element.');
				}
			}
			return errors;
		},

		getCount() {
			return this.showCountFilter ? this.countType : null;
		},

		changeCount() {
			this.$emit('updateReturnProperties');
		},

		getGradeField() {
			return (this.showGradeFieldFilter && this.isGrade) ? this.countType : null;
		},

		getGradePassValue() {
			return (this.showGradeFieldFilter && this.isGrade && this.countType) ? this.gradePassValue : null;
		},

		getParams() {
			// return data element in original vue-unfriendly format
			const params = [];

			if(this.showProcedureFilter && this.ProcedureID) {
				params.push({ProcedureID: this.ProcedureID});
			}

			if(this.showSessionType && this.SessionTypeID) {
				params.push({SessionTypeID: this.SessionTypeID});
			}

			if(this.showTSCompTestFilter && this.$config.hasModule('tests')){
				if(this.CompetencyTestID) {
					params.push({CompetencyTestID: this.CompetencyTestID});
				}
				if(this.CompetencyTestAttachedID) {
					params.push({CompetencyTestAttachedID: this.CompetencyTestAttachedID});
				}
			}

			if(this.showSpecialtyAndClinicFilters) {
				// specialties
				const specialtyIds = [];
				for(let specialty of this.selectedSpecialties) {
					specialtyIds.push(specialty.id);
				}
				params.push({SpecialtyID: specialtyIds});
				/* ---------- ---------- */

				// clinics
				const clinicIds = [];
				for(let clinic of this.selectedClinics) {
					clinicIds.push(clinic.id);
				}
				params.push({ClinicID: clinicIds});
				/* ---------- ---------- */
			}

			if(this.showFormElementFilter) {
				for(let formElement of this.selectedFormElements) {
					params.push({formelement_name: formElement.Name, value: formElement.value});
				}
			}

			if(this.showFormFilters) {
				var formids = [];
				for(let form of this.selectedForms) {
					formids.push(form.id);
					//params.push({FormID: form.id});
				}
				if(formids.length){
					params.push({form_id: formids});
				}

				for(let formField of this.selectedFormFields) {
					const param = {formfield_name: formField.name, value: formField.value};
					if(formField.type == 'number') {
						param.min = formField.min;
						param.max = formField.max;
					}
					params.push(param);
				}
			}

			if(this.showCompetencyTestFilters) {
				for(const filter of Object.keys(this.competencyTestFilters)) {
					params.push({name:filter, value: this.competencyTestFilters[filter]});
				}
			}

			if(this.showTagFilters) {
				var tagids = [];
				for(let tag of this.selectedTags) {
					tagids.push(tag.id);
				}
				if(tagids.length){
					params.push({tags: tagids});
				}
			}

            if(this.form_statuses.completed) params.push({completed:true});
            if(this.form_statuses.reviewed) params.push({reviewed:true});
            if(this.form_statuses.signed_off) params.push({signed_off:true});

            if(this.user_subject) params.push({user_subject:true})


			return params;

		},

		resetData() {
			this.ProcedureID = null;
			this.CompetencyTestID = null;
			this.selectedSpecialties = [];
			this.selectedFormElements = [];
			this.selectedClinics = [];
			this.countType = null;
			this.isGrade = false;
			this.gradePassValue = null;
			this.selectedForms = [];
			this.selectedFormFields = [];
		},

		loadDataElement() {
			if(this.dataelement.data.count) {
				this.countType = this.dataelement.data.count;
				this.changeCount();
			}
			if(this.dataelement.data.gradefield) {
				this.isGrade = true;
			}
			if(this.dataelement.data.gradepassvalue) {
				this.gradePassValue = this.dataelement.data.gradepassvalue;
			}
			if(this.dataelement.data.divisor) {
				this.divisor = this.dataelement.data.divisor;
			}
			this.loadParams();
		},

		getDivisor() {
			return this.datasource == 'formscores' ? this.divisor : null;
		},

		loadParams() {

			for(let param of this.dataelement.data.params) {

				// procedure
				if(Object.hasOwnProperty.call(param, 'ProcedureID') && !this.ProcedureID) {
					this.ProcedureID = param.ProcedureID;
					this.getFormElements().then(() => {
						// load rest of params - this will be skipped next time as procedureID will be set
						this.loadParams();
					});
					break;
				}

				// procedure
				if(Object.hasOwnProperty.call(param, 'SessionTypeID') && !this.SessionTypeID) {
					this.SessionTypeID = param.SessionTypeID;
				}

				// form elements
				if(Object.hasOwnProperty.call(param, 'formelement_name')) {
					this.selectFormElementByName(param.formelement_name, param.value);
				}

				// form fields
				if(Object.hasOwnProperty.call(param, 'formfield_name')) {
					this.selectFormFieldByName(param.formfield_name, param.value, param.min, param.max);
				}

				/*
				// form fields
				if(Object.hasOwnProperty.call(param, 'ttsessiontype_id')) {
					this.selectFormFieldByName(param.formfield_name, param.value, param.min, param.max);
				}
				*/

				if(Object.hasOwnProperty.call(param, 'SpecialtyID')) {
					for(let id of param.SpecialtyID) {
						let specialty = this.getSpecialtyById(id)
						if(specialty) {
							this.selectedSpecialties.push(specialty);
						}
					}
				}

				if(Object.hasOwnProperty.call(param, 'ClinicID')) {
					for(let id of param.ClinicID) {
						let	clinic = this.getClinicById(id)
						if(clinic) {
							this.selectedClinics.push(clinic);
						}
					}
				}

				// competency test
				if(Object.hasOwnProperty.call(param, 'CompetencyTestID')) {
					this.CompetencyTestID = param.CompetencyTestID;
				}
				if(Object.hasOwnProperty.call(param, 'CompetencyTestAttachedID')) {
					this.CompetencyTestAttachedID = param.CompetencyTestAttachedID;
				}

				if(Object.hasOwnProperty.call(param, 'name')) {
					this.competencyTestFilters[param.name] = param.value;
				}

				if(Object.hasOwnProperty.call(param, 'form_id')) {
					for(let id of param.form_id) {
						let	form = this.getFormById(id)
						if(form) {
							this.selectedForms.push(form);
						}
					}
				}

				// form status
				if(Object.hasOwnProperty.call(param, 'completed')) {
					this.form_statuses.completed = param.completed;
				}
				if(Object.hasOwnProperty.call(param, 'reviewed')) {
					this.form_statuses.reviewed = param.reviewed;
				}
				if(Object.hasOwnProperty.call(param, 'signed_off')) {
					this.form_statuses.signed_off = param.signed_off;
				}

                // form is about another subject

                if(Object.hasOwnProperty.call(param, 'user_subject')) {
					this.user_subject = param.user_subject;
				}

				if(Object.hasOwnProperty.call(param, 'tags')) {
					for(let id of param.tags) {
						let	tag = this.$config.getTagById(id)
						if(tag) {
							this.selectedTags.push(tag);
						}
					}
				}

			}

		},

		/* ---------- ---------- Specialties ---------- ---------- */
		getSpecialtyById(id) {
			for(let specialty of this.specialties) {
				if(specialty.id == id) {
					return specialty;
				}
			}
		},

		openSpecialtiesModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Specialties',
				selectCallback: function(selection) {
					const isSelected = self.selectedSpecialties.find((specialty, i) => {
						if (specialty.id === selection.id) {
							self.$delete(self.selectedSpecialties, i);
							return true;
						}
					});
					if (!isSelected) {
						self.selectedSpecialties.push(selection);
					}
				},
				selected: this.selectedSpecialties,
				data: this.specialties,
				captionKey: "caption"
			});
		},

		removeSpecialty(selection) {
			const self = this;
			self.selectedSpecialties.find((specialty, i) => {
				if (specialty.id === selection.id) {
					self.$delete(self.selectedSpecialties, i);
					return true;
				}
			});
			return false;
		},
		/* ---------- ---------- ---------- ---------- ---------- */



		/* ---------- ---------- Clinics ---------- ---------- */
		getClinicById(id) {
			for(let clinic of this.clinics) {
				if(clinic.id == id) {
					return clinic;
				}
			}
		},

		openGradesModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select',
				selectCallback: function(selection) {
					const isSelected = self.dataelement.data.grades.find((grade, i) => {
						if (grade.id === selection.id) {
							self.$delete(self.dataelement.data.grades, i);
							return true;
						}
					});
					if (!isSelected) {
						self.dataelement.data.grades.push({
							"id": selection.id ,
							"caption": selection.caption ,
							"proceduregrade": ((('proceduregrade' in selection) && selection.proceduregrade)?true:false) ,
							"marks": []
						});
					}
				},
				selected: this.dataelement.data.grades,
				data: this.grades,
				captionKey: "caption"
			});
		},

		removeGrade(selection) {
			const self = this;
			self.dataelement.data.grades.find((grade, i) => {
				if (grade.id === selection.id) {
					self.$delete(self.dataelement.data.grades, i);
					return true;
				}
			});
			return false;
		},

		openGradeValuesModal(grade) {
			const self = this;
			this.grades.find((item) => {
				if (grade.id === item.id) {
					this.$store.commit("openModal", {
						type: "selector",
						title: 'Select',
						selectCallback: function(selection) {
							const isSelected = grade.marks.find((option, i) => {
								if (option === selection.value) {
									self.$delete(grade.marks, i);
									return true;
								}
							});
							if (!isSelected) {
								grade.marks.push(selection.value);
							}
						},
						selected: grade.marks,
						data: item.values,
						idProperty: 'value',
						captionKey: "caption"
					});
				}
			});
		},

		removeGradeValue(grade, selection) {
			this.dataelement.data.grades.find((item) => {
				if (grade.id === item.id) {
					item.marks.forEach((mark, i) => {
						if (mark === selection) {
							this.$delete(item.marks, i);
							return true;
						}
					});
				}
			});
			return false;
		},

		getGradeCaption(grade, selection) {
			var caption = '';
			this.grades.find((item) => {
				if (grade.id === item.id) {
					item.values.forEach((option) => {
						if (option.value === selection) {
							caption = option.caption;
						}
					});
				}
			});
			return caption;
		},

		openClinicsModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Clinics',
				selectCallback: function(selection) {
					const isSelected = self.selectedClinics.find((clinic, i) => {
						if (clinic.id === selection.id) {
							self.$delete(self.selectedClinics, i);
							return true;
						}
					});
					if (!isSelected) {
						self.selectedClinics.push(selection);
					}
				},
				selected: this.selectedClinics,
				data: this.clinics,
				captionKey: "name"
			});
		},

		removeClinic(selection) {
			const self = this;
			self.selectedClinics.find((clinic, i) => {
				if (clinic.id === selection.id) {
					self.$delete(self.selectedClinics, i);
					return true;
				}
			});
			return false;
		},
		/* ---------- ---------- ---------- ---------- ---------- */



		/* ---------- ---------- Form Elements ---------- ---------- */
		getFormElementByName(name) {
			for(let formElement of this.formElements) {
				if(formElement.Name == name) {
					return formElement;
				}
			}
		},

		selectFormElementByName(name, value = null) {
			const formElement = this.getFormElementByName(name);
			if(formElement) {
				this.selectFormElement(formElement, value);
			}
		},

		getFormElements() {
			this.formElements = [];
			this.selectedFormElements = [];
  			return this.$cfetch(`${this.$settings.APIBaseURL}/reporting/alldata/formelementlist`, {
  				data: {
  					procedure_id : this.ProcedureID
  				}
  			})
			.then(json => {
				this.formElements = json;
			}).catch(error => {
				this.$log.error.call(this, error);
			});
		},

		getFormElementSelectOptions(formElement) {
			formElement.selectOptions = [];
  			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/alldata/selectvaluelist`, {
  				data: {
  					formelement_id : formElement.FormElementID
  				}
  			})
			.then(json => {
				formElement.selectOptions = json;
			}).catch(error => {
				this.$log.error.call(this, error);
			});
		},

		selectFormElement(selection, value = []) {

			const formElement = JSON.parse(JSON.stringify(selection));

			if(formElement.Type == 'select' || formElement.Type == 'multiselect') {
				this.getFormElementSelectOptions(formElement);
			}
			formElement.value = Array.isArray(value) ? value : [value];
			this.selectedFormElements.push(formElement);
		},

		openFormElementsModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Form Elements',
				selectCallback: function(selection) {
					const isSelected = self.selectedFormElements.find((formElement, i) => {
						if (formElement.FormElementID === selection.FormElementID) {
							self.$delete(self.selectedFormElements, i);
							return true;
						}
					});
					if (!isSelected) {
						self.selectFormElement(selection);
					}
				},
				selected: this.selectedFormElements,
				data: this.formElements,
				captionKey: "Name",
				idProperty: 'FormElementID'
			});
		},

		removeFormElement(selection) {
			const self = this;
			self.selectedFormElements.find((formElement, i) => {
				if (formElement.FormElementID === selection.FormElementID) {
					self.$delete(self.selectedFormElements, i);
					return true;
				}
			});
			return false;;
		},

		getFormElementValueCaptionFromValue(formElement, value) {
			const options = this.getFormElementValueOptions(formElement);
			for(const option of options) {
				if(option.Value == value) {
					return option.Caption;
				}
			}
			return null;
		},

		getFormElementValueOptions(formElement) {
			let options = [];
			if(formElement.Type == 'bool' || formElement.Type == 'nullablebool') {
				options.push({
					Value: 'true',
					Caption: this.$t('true')
				});
				options.push({
					Value: 'false',
					Caption: this.$t('false')
				});
				if(formElement.Type == 'nullablebool') {
					options.push({
						Value: 'notnull',
						Caption: this.$t('not-null')
					})
				}
			} else if(formElement.Type == 'toothmap') {
				options.push({
					Value: 'toothmap_incisor',
					Caption: this.$t('incisor')
				});
				options.push({
					Value: 'toothmap_canine',
					Caption: this.$t('canine')
				});
				options.push({
					Value: 'toothmap_premolar',
					Caption: this.$t('premolar')
				});
				options.push({
					Value: 'toothmap_molar',
					Caption: this.$t('molar')
				});
				options.push({
					Value: 'toothmap_nonmolar',
					Caption: this.$t('non-molar')
				});
				options.push({
					Value: 'toothmap_posterior',
					Caption: this.$t('posterior')
				});
				options.push({
					Value: 'toothmap_anterior',
					Caption: this.$t('anterior')
				});
				options.push({
					Value: 'toothmap_adult',
					Caption: this.$t('Adult')
				});
				options.push({
					Value: 'toothmap_infant',
					Caption: this.$t('Primary')
				});
				options.push({
					Value: 'quadrants_1',
					Caption: this.$t('1-quadrant')
				});
				options.push({
					Value: 'quadrants_1+',
					Caption: this.$t('1-or-more-quadrants')
				});
				options.push({
					Value: 'quadrants_2',
					Caption: this.$t('2-quadrants')
				});
				options.push({
					Value: 'quadrants_2+',
					Caption: this.$t('2-or-more-quadrants')
				});
				options.push({
					Value: 'quadrants_3',
					Caption: this.$t('3-quadrants')
				});
				options.push({
					Value: 'quadrants_3+',
					Caption: this.$t('3-or-more-quadrants')
				});
				options.push({
					Value: 'quadrants_4',
					Caption: this.$t('4-quadrants')
				});
			} else if(formElement.Type == 'select' || formElement.Type == 'multiselect') {
				options = formElement.selectOptions;
			} else if(formElement.Type == 'multiplier') {
				for(let i = 0; i < formElement.max; i++) {
					options.push({
						Value: i,
						Caption: i
					})
				}
			}

			return options;
		},

		openFormElementValuesModal(formElement) {

			const data = this.getFormElementValueOptions(formElement);

			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Values',
				selectCallback: function(selection) {
					const isSelected = formElement.value.find((value, i) => {
						if (value === selection.Value) {
							self.$delete(formElement.value, i);
							return true;
						}
					});
					if (!isSelected) {
						formElement.value.push(selection.Value);
					}
				},
				selected: formElement.value,
				data,
				captionKey: "Caption",
				idProperty: 'Value'
			});
		},

		removeFormElementValue(selection, formElement) {
			const self = this;
			formElement.value.find((value, i) => {
				if (value === selection) {
					self.$delete(formElement.value, i);
					return true;
				}
			});
			return false;;
		},
		/* ---------- ---------- ---------- ---------- ---------- */


		/* ---------- ---------- Forms ---------- ---------- */
		getFormById(id) {
			for(let form of this.forms) {
				if(form.id == id) {
					return form;
				}
			}
		},

		openFormsModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Forms',
				selectCallback: function(selection) {
					const isSelected = self.selectedForms.find((form, i) => {
						if (form.id === selection.id) {
							self.$delete(self.selectedForms, i);
							return true;
						}
					});
					if (!isSelected) {
						self.selectedForms.push(selection);
					}
				},
				selected: this.selectedForms,
				data: this.forms,
				captionKey: "title"
			});
		},

		removeForm(selection) {
			const self = this;
			self.selectedForms.find((form, i) => {
				if (form.id === selection.id) {
					self.$delete(self.selectedForms, i);
					return true;
				}
			});
			return false;
		},
		/* ---------- ---------- ---------- ---------- ---------- */


		/* ---------- ---------- Form Fields ---------- ---------- */
		getFormFieldByName(name) {
			for(let formField of this.formFields) {
				if(formField.name == name) {
					return formField;
				}
			}
		},

		selectFormFieldByName(name, value = null, min = null, max = null) {

			const formField = this.getFormFieldByName(name);
			if(formField) {
				this.selectFormField(formField, value, min, max);
			}
		},

		selectFormField(selection, value = [], min = null, max = null) {

			const formField = JSON.parse(JSON.stringify(selection));

			formField.value = Array.isArray(value) ? value : [value];
			if(formField.type == 'number') {
				formField.min = min;
				formField.max = max;
			}
			this.selectedFormFields.push(formField);
		},

		openFormFieldsModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Form Fields',
				selectCallback: function(selection) {
					const isSelected = self.selectedFormFields.find((formField, i) => {
						if (formField.name === selection.name) {
							self.$delete(self.selectedFormFields, i);
							return true;
						}
					});
					if (!isSelected) {
						self.selectFormField(selection);
					}
				},
				selected: this.selectedFormFields,
				data: this.filteredFormFields,
				captionKey: "caption",
				idProperty: 'name'
			});
		},

		removeFormField(selection) {
			const self = this;
			self.selectedFormFields.find((formField, i) => {
				if (formField.name === selection.name) {
					self.$delete(self.selectedFormFields, i);
					return true;
				}
			});
			return false;;
		},

		fieldInSelectedForms(field) {
			for(let form of this.selectedForms) {
				if(form.id == field.form_id) {
					return true;
				}
			}
			return false;
		},

		getFormFieldValueCaptionFromValue(formField, value) {
			const options = this.getFormFieldValueOptions(formField);
			for(const option of options) {
				if(option.value == value) {
					return option.caption;
				}
			}
			return value;
		},

		getFormFieldValueOptions(formField) {

			let options = [];
			if(formField.type == 'bool') {
				options.push({
					value: 'true',
					caption: this.$t('true')
				});
				options.push({
					value: 'false',
					caption: this.$t('false')
				});
			} else if(formField.type == 'select' || formField.type == 'multiselect') {
				if(Array.isArray(formField.options)) {
					options = formField.options;
				} else if(typeof formField.options == 'object' && formField.options.optionsfromconfig) {
					for(let option of this.$config.getValue(formField.options.optionsfromconfig)) {
						options.push({
							value: option.id,
							caption: (option.name?option.name:option.id)
						})
					}
				}
			}
			return options;
		},

		openFormFieldValuesModal(formField) {

			const data = this.getFormFieldValueOptions(formField);

			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Values',
				selectCallback: function(selection) {
					const isSelected = formField.value.find((value, i) => {
						if (value === selection.value) {
							self.$delete(formField.value, i);
							return true;
						}
					});
					if (!isSelected) {
						formField.value.push(selection.value);
					}
				},
				selected: formField.value,
				data,
				captionKey: "caption",
				idProperty: 'value'
			});
		},

		removeFormFieldValue(selection, formField) {
			const self = this;
			formField.value.find((value, i) => {
				if (value === selection) {
					self.$delete(formField.value, i);
					return true;
				}
			});
			return false;;
		},
		/* ---------- ---------- ---------- ---------- ---------- */



		/* ---------- ---------- TTSessiontypes ---------- ---------- */

		getTTSessiontypes() {
			this.formElements = [];
			this.selectedFormElements = [];
  			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/sessiontypes/all`, {
  				data: {
  					all: true
  				}
  			})
			.then(json => {
				if(json.status == 'SUCCESS'){
					this.ttsessiontypes = json.results;
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
		},
		openTTSessiontypesModal(paramtype) {
			const self = this;
			if(!paramtype){
				paramtype = [];
			}
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('session-type'),
				selectCallback: function(selection) {
					const isSelected = paramtype.find((item, i) => {
						if (item.id === selection.id) {
							self.$delete(paramtype, i);
							return true;
						}
					});
					if (!isSelected) {
						paramtype.push(selection)
					}
				},
				selected: paramtype,
				data: this.ttsessiontypes,
				captionKey: 'name',
				idProperty: 'id'
			});
		},

		removeTTSessiontype(paramtype, item) {
			const self = this;
			paramtype.find((value, i) => {
				if (value.id === item.id) {
					self.$delete(paramtype, i);
					return true;
				}
			});
			return false;;
		},
		/* ---------- ---------- ---------- ---------- ---------- */



		toggleDateFilters: function() {
			if(this.showdatefilters){
				this.showdatefilters = false;
				this.dataelement.data.date_range_from = null;
				this.dataelement.data.date_range_length = null;
			} else {
				this.showdatefilters = true;
			}
		},


	},
	computed: {
		filteredFormFields() {
			return this.formFields.filter(field => {
				console.log(field);
				if(!field.caption) { // we can't select it if we can't see what it is!
					field.caption = field.name;
				}
				if(['bool', 'select', 'multiselect', 'number'].includes(field.type)) { // only bools, selects and numbers
					if(!this.selectedForms.length || this.fieldInSelectedForms(field)) { // no forms selected or field in selected forms
						return true;
					}
				}
				return false;
			});
		},
		showGradeFilters() {
			return ['formelement', 'procedure', 'toothchart', 'radiograph'].includes(this.datasource);
		},
		showProcedureFilter() {
			return ['formelement', 'procedure', 'toothchart', 'radiograph'].includes(this.datasource);
		},
		showSessionType() {
			return ['treatmentsession', 'procedures', 'formelement', 'procedure', 'toothchart', 'radiograph', 'treatmentsessionreflections', 'treatmentsessionfeedback'].includes(this.datasource);
		},
		showTSCompTestFilter() {
			return ['treatmentsession', 'procedure', 'formelement', 'toothchart', 'radiograph'].includes(this.datasource) && this.ProcedureID;
		},
		showSpecialtyAndClinicFilters() {
			return ['treatmentsession', 'formelement', 'procedure', 'toothchart', 'radiograph', 'absences', 'treatmentsessionreflections', 'treatmentsessionfeedback'].includes(this.datasource);
		},
		showCountFilter() {
			return (this.datasource == 'formelement' || this.datasource == 'form');
		},
		showGradeFieldFilter() {
			return (this.datasource == 'form');
		},
		gradeFieldOptions() {
			if(!this.countType) {
				return [];
			}
			const formField = this.selectedFormFields.find(field => field.name == this.countType);
			return (formField && Array.isArray(formField.options)) ? formField.options : [];
		},
		showFormElementFilter() {
			return ['formelement', 'toothchart', 'radiograph'].includes(this.datasource) && this.ProcedureID;
		},
		showTTSessiontypeFilters() {
			return ['attendance'].includes(this.datasource);
		},
		showCompetencyTestFilters() {
			return (this.datasource == 'competencytestpass');
		},
		showFormFilters() {
			return (this.datasource == 'form' || this.datasource == 'formscores');
		},
		showTagFilters() {
			return (this.datasource == 'attendance');
		}
	}
};
</script>
